import React, { useState } from 'react';
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from '@material-ui/lab';
import {useStylesTF,useStylesTD} from '../../../../St/comps/UseStyle';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
const usersType = [
  {id:1, label:'system-admin'},
  {id:2, label:'user'}
];

export default function UsersForm(props){
    const { t } = useTranslation(['forms']);
    const { 
      object,
      data,
      onChange,
      onShow,
      AutoOptions
      } = props;
    const clasTF = useStylesTF();
    const clasTD = useStylesTD();
    useEffect(()=>{
      console.log('dad', object)
    })
    const onChangeData = (prop) => (event) =>{

      onChange(event, {name: prop, value: event.target.value});
    } 
    const [salesmans, setSalesmans] = useState(() => {
      return [{ id: 0, name: t("without") }, ...AutoOptions.salesmen];
  });
    return(
        <React.Fragment>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <Autocomplete // classes={clasAo}
              value={object}
              onChange={(event, newValue) => { 
                  onShow({...newValue, 
                    nName: newValue.name, nPassword:''}, props.formType);
              }}
              id="controllable-states-dem" size="small"
              options={data}
              getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
              //style={{  }}  // disabled={}
              disabled={object.type=='main'}
              disableClearable
              renderInput={(params) => <TextField id="valuePricePay" {...params} label={t("employee")} 
              variant="outlined" size="small" 
                    />}
                  />
        </Grid> 
        <Grid item lg={2} md={2} sm={4} xs={6}>
          
            <Autocomplete // classes={clasAo}
              value={object?.Usertype == 1? usersType[0]: usersType[1]}
              onChange={(event, newValue) => { 
                  onChange(null, {name:'Usertype', value: newValue.id});
              }}
              id="controllable-states-dem" size="small"
              options={usersType}
              getOptionLabel={(option) => (typeof option === 'string' ? option : option.label ? t(option.label) : option.name)}
              //style={{  }}  // disabled={}
              // disabled={object.type=='main'}
              disableClearable
              renderInput={(params) => <TextField id="valuePricePay" {...params} label={t("user-type")} 
              variant="outlined" size="small" 
                    />}
                  />
        </Grid> 
        <Grid item lg={3} md={3} sm={4} xs={6}>
            <TextField fullWidth variant="outlined" size="small" 
            id={"nName"} label={t("username")}
            className={clasTF.rootSale} 
            InputProps={{ className: clasTD.input }}
            type="text" 
            name={"nName"} 
            value={object.nName} 
            onChange={(e)=>onChange(null, {name:'nName', value: e.target.value})}
            />
        </Grid> 
       
        <Grid item lg={3} md={3} sm={4} xs={6}>
            <TextField fullWidth variant="outlined" size="small" 
            id={"nPassword"} label={t("password")}
            className={clasTF.rootSale} 
            InputProps={{ className: clasTD.input }}
            type="text" 
            name={"nPassword"} 
            value={object.nPassword} 
            onChange={onChangeData('nPassword')}
            />
        </Grid> 
        <Grid item lg={2} md={2} sm={4} xs={6}>
            <Autocomplete // classes={clasAo}
              value={object.safe}
              onChange={(event, newValue) => { 
                  onChange(null, {name:'safe', value: newValue});
              }}
              id="controllable-safe-dem" size="small"
              options={object.SafeEmp}
              getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
              //style={{  }}  // disabled={}
              disableClearable
              renderInput={(params) => <TextField id="valuePricePay" {...params} label={t("default-safe")} 
              variant="outlined" size="small" 
                    />}
                  />
        </Grid> 
        <Grid item lg={2} md={2} sm={4} xs={6}>
            <Autocomplete // classes={clasAo}
              value={object.stock}
              onChange={(event, newValue) => { 
                  onChange(null, {name:'stock', value: newValue});
              }}
              id="controllable-safe-dem" size="small"
              options={object.StockEmp}
              getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
              //style={{  }}  // disabled={}
              disabled={object?.type=='main'}
              disableClearable
              renderInput={(params) => <TextField id="valuePricePay" {...params} label={t("default-cashbox")} 
              variant="outlined" size="small" 
                    />}
                  />
        </Grid> 
        <Grid item lg={2} md={2} sm={4} xs={6}>
            <Autocomplete // classes={clasAo}
              value={object.center}
              onChange={(event, newValue) => { 
                  onChange(null, {name:'center', value: newValue});
              }}
              id="controllable-safe-dem" size="small"
              options={AutoOptions.center}
              getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
              // disabled={object.type=='main'}
              disableClearable
              renderInput={(params) => <TextField id="valuePricePay" {...params} label={t("cost-center")} 
              variant="outlined" size="small" 
                    />}
                  />
        </Grid> 
        <Grid item lg={2} md={2} sm={4} xs={6}>
            <Autocomplete // classes={clasAo}
              value={object.salesmen}
              onChange={(event, newValue) => { 
                  onChange(null, {name:'salesmen', value: newValue});
              }}
              id="controllable-safe-dem" size="small"
              options={salesmans}
              getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
              disableClearable
              renderInput={(params) => <TextField id="valuePricePay" {...params} label={t("salesman")} 
              variant="outlined" size="small" 
                    />}
                  />
        </Grid> 
      </React.Fragment>
    )
    
}